/*
 * RESADE rs-loox-klick.js
 * Runde 3d (12.10.2026, Denny: „Ja, umbauen“ auf „Soll Loox erst nach einem Klick laden statt auf jeder Seite ohne
 * Einwilligung?“). Gehört zu snippets/rs-loox-laden.liquid; Adresse und Kennung kommen aus snippets/rs-loox-quelle.liquid
 * (Shop-Metafelder loox.global_html_body und loox.global_html_head, bei jedem Rendern gelesen).
 *
 * Runde 3f (13.10.2026, Denny: „Das soll halt sagen, das sagen unsere Kunden. Und dann soll halt direkt Loox kommen. Das
 * heißt, die drei Reviews, die man so swipen kann, die kommen halt weg.“): Bereiche mit data-rs-loox-auto laden das
 * Widget ohne Klick, sobald sie in die Nähe des Bildschirms kommen (IntersectionObserver mit NAEHE Vorlauf). Den
 * Beobachter richtet die Datei erst nach dem Ereignis load ein (Ladezeit-Regel 2: fremde Skripte und Iframes nicht beim
 * Laden der Seite). Der Platz steht vom Seitenaufbau an mit der geschätzten Höhe im HTML (aria-busy, rs-inhalt-a.css);
 * beim Laden ohne Klick bleibt der Fokus, wo er ist, und es gibt keine Ansage. Scheitert der Lader, stehen Knopf und
 * Zeile da: Liegt der Platz im Bild oder schon darüber, bleibt er in seiner Höhe stehen (data-rs-loox-halten); nur ganz
 * unter dem Bild klappt er zusammen, dort verschiebt sich im Bild nichts. Darüber rückte sonst in Browsern ohne
 * Scroll-Verankerung der gelesene Inhalt um die ganze Reservierung nach oben. Die Meldung steht ohne Klick nur, wenn der
 * Platz beim Scheitern im Bild liegt, und nur dann wird sie angesagt: Wer das Laden nicht gesehen hat (etwa weil ein
 * Werbeblocker die Server von Loox sperrt und der Lader scheitert, bevor der Platz ins Bild kommt), bekommt keine
 * Fehlermeldung zu etwas, das er nicht angestoßen hat (Nachbesserung 13.10.2026). Nach einem Klick auf den Knopf gilt
 * der Klickweg mit Meldung, Ansage und Fokus. Ohne IntersectionObserver oder im Datensparmodus
 * (navigator.connection.saveData) lädt nichts ohne Klick: Der Platz klappt gleich zu, der Knopf steht da. Der Knopf lädt
 * auf Klick wie in Runde 3d.
 *
 * Runde 3g (13.10.2026): Die Küchenzeile springt wie die Sternezeile der Kaufbühne auf den Kopf des Bewertungsbereichs
 * (#bewertungen-kennzahl). Ein Rautenlink im selben Fenster, dessen Ziel im Bewertungsbereich liegt (dazu #bewertungen
 * und #alle-bewertungen), lädt einen Bereich mit data-rs-loox-auto sofort, auch vor dem Ereignis load, ohne Fokus und
 * ohne Ansage wie bei der Annäherung (sprungLaden, aufgerufen im einen Klick-Hörer). Sonst stünde nach dem Sprung nur
 * der leere Platz da, bis die Annäherung nach load beginnt. Das Laden folgt dem Klick, nicht dem Laden der Seite. Kein
 * Laden bei Zusatztasten (Strg, Umschalt, Alt, Befehl), einer anderen Maustaste, einem anderen Fenster (target), einem
 * schon verhinderten Klick, ohne IntersectionObserver oder im Datensparmodus (dort steht der Knopf). Ein Bereich, der
 * schon lädt, fertig oder gescheitert ist, bleibt, wie er ist, und die Annäherung überspringt ihn ebenso: Es kommt nie
 * ein zweiter Lader, und nach einem Fehler lädt allein der Knopf erneut.
 *
 * Der Text unten zum Klick gilt für Bereiche ohne data-rs-loox-auto und für den Knopf nach einem Fehler.
 *
 * Vor dem Klick fragt die Seite keinen Server von Loox an. Diese Datei hängt nur einen Klick-Hörer an das Dokument und
 * blendet beim Start Knöpfe aus, deren Adresse das Muster unten nicht erfüllt (rs-loox-quelle verlangt seit der
 * Nachbesserung vom 13.10.2026 dieselbe Form, ein solcher Knopf kommt also gar nicht erst ins HTML). Der Klick auf
 * [data-rs-loox-laden]
 *   1. prüft die Adresse noch einmal (https://loox.io/widget/<Kunde>/<Datei>.js, Abfrage nur aus sicheren Zeichen),
 *   2. blendet Knopf und Zeile aus und zeigt den Platz darunter mit der geschätzten Höhe des Widgets (aria-busy,
 *      rs-inhalt-a.css); der Fokus geht auf den Platz (Bereich mit Namen, tabindex -1, ohne zu scrollen), auch wenn der
 *      Knopf beim Klick keinen Fokus bekam (Safari und Firefox am Mac, VoiceOver am iPhone): Sonst verschwände das
 *      bediente Element und der Fokus fiele auf body. Nach einem Mausklick zeigt :focus-visible keinen Ring,
 *   3. legt im Platz #looxReviews mit den Angaben des Widgets an (data-lx-…),
 *   4. gibt loox_global_hash und loox_bundle_reviews_enabled an Loox wie die App-Einbettung,
 *   5. hängt den Lader an, einmal je Seite. Ist Loox schon da (window.LOOX), kommt kein zweiter dazu: Loox sucht
 *      #looxReviews jede Sekunde selbst.
 * Ein zweiter Klick während des Ladens ändert nichts, auch die Uhr läuft weiter.
 * Fertig ist das Widget, sobald das Iframe von Loox mindestens 200 px hoch ist (Loox legt es mit der Höhe 0 an und setzt
 * die Höhe per postMessage): Die Reservierung fällt weg, der Status meldet es, das Iframe bekommt den deutschen Titel.
 * Scheitert der Lader oder steht nach 15 s kein Widget, wird #looxReviews entfernt, Knopf und Zeile kommen mit der
 * Meldung zurück, der Fokus geht auf den Knopf; ein zweiter Klick versucht es erneut (nach einem Fehler des Laders mit
 * einem frischen Skript, sonst mit dem geladenen). Kommt der Fehler später als 300 ms nach dem Klick, bleibt der Platz in
 * seiner Höhe stehen, und Knopf, Meldung und Zeile stehen oben darin (data-rs-loox-halten, rs-inhalt-a.css): Sonst rückte
 * der Inhalt darunter ohne Eingabe um fast 2.000 px nach oben, eine gezählte Layout-Verschiebung (Nachbesserung
 * 13.10.2026). Ein früher Fehler (etwa ein Werbeblocker) klappt den Platz zusammen; das zählt noch zur Eingabe.
 * Ohne JavaScript bleibt der Knopf aus (rs-nur-js), dann gilt das noscript mit den neuesten Bewertungen.
 *
 * Teil 9 (13.10.2026): Hinweis für Links aus Mails von Loox (snippets/rs-loox-link.liquid, Aussehen in rs-base.css,
 * Abschnitt 15). Passt die Adresse der Seite auf die Muster von Loox (?lx=, ?lx_ep=, qv=, ref=review), markiert das
 * kleine Skript im Snippet die Vorlage und lädt diese Datei; wo der Bewertungsbereich steht, ist sie schon im HTML.
 * linkZeigen setzt den Hinweis als erstes Element in den body, ohne den Fokus zu bewegen. Der Klick auf „Formular von
 * Loox öffnen“ prüft die Adresse mit demselben Muster ADRESSE, gibt Kennung und Bündel-Schalter weiter, blendet den
 * Hinweis aus, setzt den Fokus
 * ohne Scrollen auf den Anfang des Inhalts (#MainContent; Loox merkt sich dieses Element und gibt ihm den Fokus zurück,
 * wenn sein Fenster schließt) und hängt den Lader an, einmal je Seite wie beim Set. Der Lader liest die Adresse der
 * Seite und öffnet sein Fenster. Ist er geladen, fällt der Hinweis weg; scheitert er oder kommt nach 15 s nichts, steht
 * der Hinweis mit der Meldung wieder da, der Fokus auf seinem Knopf (nur, wenn er noch am Anfang des Inhalts stand).
 * „Schließen“ und Escape nehmen den Hinweis weg, Escape nur, wenn der Fokus im Hinweis oder nirgends steht (sonst gehört
 * die Taste etwa der Schublade). Lädt der Bewertungsbereich den Lader (Klick, Annäherung oder Sprunglink), fällt der
 * Hinweis ebenfalls weg: Loox liest die Adresse dann selbst.
 */
(function () {
  'use strict';
  if (window.rsLooxKlick) {
    // zweite Einbindung (Skript im Hinweis für Links aus Mails von Loox): nur den Hinweis prüfen, kein zweiter Hörer
    if (typeof window.rsLooxKlick.linkZeigen === 'function') window.rsLooxKlick.linkZeigen();
    return;
  }
  window.rsLooxKlick = { linkZeigen: linkZeigen };

  var ADRESSE = /^https:\/\/loox\.io\/widget\/[A-Za-z0-9_-]+\/[A-Za-z0-9._-]+\.js(\?[A-Za-z0-9._~%&=-]*)?$/;
  var KENNUNG = /^\d{1,20}$/;
  var FERTIG_AB = 200; // px Höhe des Iframes
  var GEDULD = 15000; // ms bis zur Meldung
  var TAKT = 500; // ms, Prüfung zusätzlich zum ResizeObserver
  var FRISCH = 300; // ms nach dem Klick: Ein Fehler bis dahin klappt den Platz zusammen, ein späterer lässt ihn stehen
  var NAEHE = '150% 0px'; // Runde 3f: Vorlauf der Annäherung, anderthalb Fensterhöhen über und unter dem Bildschirm
  // Angaben des Widgets aus data-lx-… (rs-loox-laden.liquid). Seit 14.10.2026 dazu or-productids (Set und archivierter
  // Vorgänger in einer Liste) und product-thumbnails; der Lader liest data-or-productIds, HTML-Attributnamen sind klein.
  var WIDGET = ['product-id', 'limit', 'reviews-to-display', 'default-tab', 'or-productids', 'product-thumbnails'];
  var laderStand = ''; // '', 'laedt', 'da' oder 'fehler'
  var link = null; // eingesetzter Hinweis für Links aus Mails von Loox (Teil 9)
  var linkVorlage = null;
  var linkUhr = 0;
  var linkFertig = false; // einmal geschlossen oder erledigt: kommt auf dieser Seite nicht wieder

  function jetzt() {
    var p = window.performance;
    return p && typeof p.now === 'function' ? p.now() : new Date().getTime();
  }
  function teil(bereich, name) {
    return bereich.querySelector('[data-rs-loox-' + name + ']');
  }
  function text(bereich, name) {
    return bereich.getAttribute('data-text-' + name) || '';
  }
  function zustand(bereich) {
    return bereich.getAttribute('data-rs-loox-zustand') || '';
  }
  function melden(bereich, t) {
    var status = teil(bereich, 'status');
    if (status) status.textContent = t;
  }
  // Runde 3f: Lage eines Elements zum sichtbaren Fenster
  function fensterHoehe() {
    return window.innerHeight || (document.documentElement && document.documentElement.clientHeight) || 0;
  }
  // ganz oder teilweise im Bild
  function imBild(el) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return false;
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < fensterHoehe();
  }
  // ganz unter dem Bild: Nur dort klappt ein Platz zusammen, ohne dass sich im Bild etwas verschiebt
  function unterBild(el) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return false;
    return el.getBoundingClientRect().top >= fensterHoehe();
  }

  function scheitern(bereich) {
    if (zustand(bereich) !== 'laedt') return;
    if (bereich.rsLooxEnde) bereich.rsLooxEnde();
    bereich.setAttribute('data-rs-loox-zustand', 'fehler');
    var platz = teil(bereich, 'platz');
    var start = teil(bereich, 'start');
    var knopf = teil(bereich, 'laden');
    var fehler = teil(bereich, 'fehler');
    var fokusImPlatz = !!platz && platz.contains(document.activeElement);
    // nach Klick zählt die Zeit seit dem Klick (FRISCH); ohne Klick zählt die Lage des Platzes: Nur ganz unter dem Bild
    // klappt er zusammen, im Bild oder darüber bleibt er stehen. Meldung und Ansage gibt es ohne Klick nur, wenn der
    // Platz im Bild liegt (wer das Laden gesehen hat, erfährt, warum nichts kommt); sonst Knopf und Zeile ohne Meldung.
    var erklaeren = !bereich.rsLooxAuto || imBild(platz);
    var halten = bereich.rsLooxAuto ? !unterBild(platz) : jetzt() - (bereich.rsLooxSeit || 0) > FRISCH;
    if (platz) {
      var box = platz.querySelector('#looxReviews');
      if (box && box.parentNode) box.parentNode.removeChild(box);
      platz.removeAttribute('aria-busy');
      platz.hidden = !halten;
    }
    if (halten) bereich.setAttribute('data-rs-loox-halten', '');
    var t = erklaeren ? text(bereich, 'fehler') : '';
    if (fehler) {
      fehler.textContent = t;
      fehler.hidden = !t;
    }
    if (start) start.hidden = false;
    if (erklaeren) melden(bereich, t);
    if (fokusImPlatz && knopf) knopf.focus();
  }

  function fertig(bereich, platz, rahmen) {
    bereich.setAttribute('data-rs-loox-zustand', 'fertig');
    platz.removeAttribute('aria-busy');
    if (!bereich.rsLooxAuto) melden(bereich, text(bereich, 'geladen'));
    var titel = text(bereich, 'bereich');
    if (titel) rahmen.setAttribute('title', titel);
  }

  function beobachten(bereich, platz) {
    var ro = null;
    var takt = 0;
    var uhr = 0;
    function ende() {
      if (ro) ro.disconnect();
      window.clearInterval(takt);
      window.clearTimeout(uhr);
      if (bereich.rsLooxEnde === ende) bereich.rsLooxEnde = null;
    }
    function pruefen() {
      if (zustand(bereich) !== 'laedt') {
        ende();
        return;
      }
      var rahmen = platz.querySelector('iframe');
      if (rahmen && rahmen.offsetHeight >= FERTIG_AB) {
        ende();
        fertig(bereich, platz, rahmen);
      }
    }
    if (bereich.rsLooxEnde) bereich.rsLooxEnde();
    bereich.rsLooxEnde = ende;
    if (typeof window.ResizeObserver === 'function') {
      ro = new window.ResizeObserver(pruefen);
      ro.observe(platz.querySelector('#looxReviews') || platz);
    }
    takt = window.setInterval(pruefen, TAKT);
    uhr = window.setTimeout(function () {
      scheitern(bereich);
    }, GEDULD);
  }

  function laderAnhaengen(src) {
    laderStand = 'laedt';
    var skript = document.createElement('script');
    skript.async = true;
    skript.src = src;
    skript.onload = function () {
      laderStand = 'da';
      // Loox hat die Adresse der Seite beim Start gelesen und öffnet sein Fenster selbst: Der Hinweis hat seine Arbeit getan
      linkErledigt();
    };
    skript.onerror = function () {
      laderStand = 'fehler';
      if (skript.parentNode) skript.parentNode.removeChild(skript);
      // alle, die auf diesen Lader warten: Bewertungsbereiche (scheitern prüft selbst, ob sie laden) und der Hinweis
      var liste = document.querySelectorAll('[data-rs-loox-bereich]');
      for (var i = 0; i < liste.length; i++) scheitern(liste[i]);
      linkScheitern();
    };
    document.body.appendChild(skript);
  }

  // auto: Laden bei Annäherung (Runde 3f), ohne Fokus und ohne Ansage; sonst Laden nach Klick auf den Knopf
  function laden(bereich, auto) {
    var z = zustand(bereich);
    if (z === 'laedt' || z === 'fertig') return;
    var src = bereich.getAttribute('data-loox-src') || '';
    var platz = teil(bereich, 'platz');
    if (!platz || !ADRESSE.test(src)) return;
    var start = teil(bereich, 'start');
    var fehler = teil(bereich, 'fehler');

    bereich.setAttribute('data-rs-loox-zustand', 'laedt');
    bereich.rsLooxSeit = jetzt();
    bereich.rsLooxAuto = !!auto;
    bereich.removeAttribute('data-rs-loox-halten');
    var sektion = bereich.closest ? bereich.closest('[data-rs-bewertungen]') : null;
    if (sektion) sektion.classList.add('rs-bew--loox');
    if (fehler) {
      fehler.textContent = '';
      fehler.hidden = true;
    }
    var box = platz.querySelector('#looxReviews');
    if (!box) {
      box = document.createElement('div');
      box.id = 'looxReviews';
      box.className = 'loox-reviews-default';
      for (var i = 0; i < WIDGET.length; i++) {
        var wert = bereich.getAttribute('data-lx-' + WIDGET[i]);
        if (wert) box.setAttribute('data-' + WIDGET[i], wert);
      }
      platz.appendChild(box);
    }
    platz.setAttribute('aria-busy', 'true');
    platz.hidden = false;
    if (start) start.hidden = true;
    if (!auto) {
      melden(bereich, text(bereich, 'laden'));
      try {
        platz.focus({ preventScroll: true });
      } catch (e) {
        platz.focus();
      }
    }

    var hash = bereich.getAttribute('data-loox-hash') || '';
    if (KENNUNG.test(hash)) window.loox_global_hash = hash;
    window.loox_bundle_reviews_enabled = bereich.getAttribute('data-loox-bundle') === 'true';

    beobachten(bereich, platz);
    if (window.LOOX || laderStand === 'laedt' || laderStand === 'da') return;
    laderAnhaengen(src);
  }

  /* ---------- Runde 3f: Laden bei Annäherung ---------- */

  function sparen() {
    var c = window.navigator && window.navigator.connection;
    return !!(c && c.saveData);
  }
  // Kein Laden ohne Klick: Platz zu, Knopf da (wie ein Bereich ohne data-rs-loox-auto)
  function nurKnopf(bereich) {
    var platz = teil(bereich, 'platz');
    var start = teil(bereich, 'start');
    if (platz) {
      platz.removeAttribute('aria-busy');
      platz.hidden = true;
    }
    if (start) start.hidden = false;
  }
  // Runde 3g: Einen Bereich, der schon begonnen hat (etwa über einen Sprunglink, auch einen gescheiterten), beobachtet
  // und lädt die Annäherung nicht; nach einem Fehler lädt allein der Knopf erneut
  function annaehern(liste) {
    var io = new window.IntersectionObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        if (!eintraege[i].isIntersecting) continue;
        var t = eintraege[i].target;
        io.unobserve(t);
        if (!zustand(t)) laden(t, true);
      }
    }, { rootMargin: NAEHE });
    for (var j = 0; j < liste.length; j++) {
      if (!zustand(liste[j])) io.observe(liste[j]);
    }
  }
  function nachLoad(fn) {
    if (document.readyState === 'complete') {
      fn();
      return;
    }
    window.addEventListener('load', fn);
  }

  function init(wurzel) {
    var liste = (wurzel || document).querySelectorAll('[data-rs-loox-bereich]');
    var auto = [];
    for (var i = 0; i < liste.length; i++) {
      var b = liste[i];
      if (!ADRESSE.test(b.getAttribute('data-loox-src') || '')) {
        var start = teil(b, 'start');
        var platz = teil(b, 'platz');
        if (start) start.hidden = true;
        if (platz && b.hasAttribute('data-rs-loox-auto')) {
          platz.removeAttribute('aria-busy');
          platz.hidden = true;
        }
        continue;
      }
      if (!b.hasAttribute('data-rs-loox-auto') || b.rsLooxBeobachtet || zustand(b)) continue;
      b.rsLooxBeobachtet = true;
      if (typeof window.IntersectionObserver !== 'function' || sparen()) {
        nurKnopf(b);
        continue;
      }
      // Runde 3g: lädt ohne Klick auf den Knopf, bei Annäherung und über einen Sprunglink (sprungLaden)
      b.rsLooxOhneKlick = true;
      auto.push(b);
    }
    if (auto.length) {
      nachLoad(function () {
        annaehern(auto);
      });
    }
  }

  /* ---------- Runde 3g: Sprunglink zum Bewertungsbereich ---------- */

  // Rautenlink im selben Fenster, dessen Ziel im Bewertungsbereich liegt (Küchenzeile und Sternezeile der Kaufbühne auf
  // #bewertungen-kennzahl, dazu #bewertungen und #alle-bewertungen): lädt die Bereiche darin, die ohne Klick laden
  // dürfen, sofort, ohne Fokus und ohne Ansage. Nicht bei Zusatztasten, anderer Maustaste, anderem Fenster oder schon
  // verhindertem Klick; ein Bereich mit Zustand bleibt, wie er ist (nie ein zweiter Lader).
  function sprungLaden(e, a) {
    if (!a || e.defaultPrevented || e.button || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    var href = a.getAttribute('href') || '';
    var fenster = (a.getAttribute('target') || '').toLowerCase();
    if (href.length < 2 || href.charAt(0) !== '#' || (fenster && fenster !== '_self')) return;
    var ziel = null;
    try {
      ziel = document.getElementById(decodeURIComponent(href.slice(1)));
    } catch (x) {
      return; // kaputte Kodierung im Anker
    }
    var sektion = ziel && ziel.closest ? ziel.closest('[data-rs-bewertungen]') : null;
    if (!sektion) return;
    var liste = sektion.querySelectorAll('[data-rs-loox-bereich]');
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].rsLooxOhneKlick && !zustand(liste[i])) laden(liste[i], true);
    }
  }

  /* ---------- Teil 9: Hinweis für Links aus Mails von Loox (snippets/rs-loox-link.liquid) ---------- */

  function linkTeil(name) {
    return link ? link.querySelector('[data-rs-loox-link-' + name + ']') : null;
  }
  function linkMelden(t) {
    var status = linkTeil('status');
    if (status) status.textContent = t;
  }
  // Anfang des Inhalts (main mit tabindex -1, ohne Fokusring), ohne zu scrollen
  function inhaltFokus() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    try {
      main.focus({ preventScroll: true });
    } catch (e) {
      main.focus();
    }
  }

  // Setzt den Hinweis aus der Vorlage als erstes Element in den body, nur wenn das Skript im Snippet die Vorlage markiert
  // hat (Adresse der Seite passt) und Loox noch nicht da ist. Bewegt den Fokus nicht.
  function linkZeigen() {
    if (link || linkFertig || window.LOOX || laderStand === 'laedt' || laderStand === 'da') return;
    var vorlage = document.querySelectorAll('[data-rs-loox-link-an]')[0];
    if (!vorlage || !vorlage.content || !ADRESSE.test(vorlage.getAttribute('data-loox-src') || '')) return;
    var huelle = vorlage.content.querySelector('[data-rs-loox-link]');
    if (!huelle || !document.body) return;
    linkVorlage = vorlage;
    link = huelle.cloneNode(true);
    document.body.insertBefore(link, document.body.firstChild);
    document.addEventListener('keydown', linkTaste);
  }

  function linkOeffnen() {
    if (!link || link.getAttribute('data-rs-loox-zustand') === 'laedt') return;
    var src = linkVorlage.getAttribute('data-loox-src') || '';
    if (!ADRESSE.test(src)) return;
    var karte = linkTeil('karte');
    var fehler = linkTeil('fehler');
    link.setAttribute('data-rs-loox-zustand', 'laedt');
    if (fehler) {
      fehler.textContent = '';
      fehler.hidden = true;
    }
    if (karte) karte.hidden = true;
    linkMelden(linkVorlage.getAttribute('data-text-laden') || '');
    inhaltFokus();

    var hash = linkVorlage.getAttribute('data-loox-hash') || '';
    if (KENNUNG.test(hash)) window.loox_global_hash = hash;
    window.loox_bundle_reviews_enabled = linkVorlage.getAttribute('data-loox-bundle') === 'true';

    window.clearTimeout(linkUhr);
    linkUhr = window.setTimeout(linkScheitern, GEDULD);
    // Loox ist schon da und hat die Adresse beim Start gelesen; ein zweiter Lader änderte nichts
    if (window.LOOX || laderStand === 'da') {
      linkErledigt();
      return;
    }
    // der Bewertungsbereich lädt schon: onload oder onerror melden sich
    if (laderStand === 'laedt') return;
    laderAnhaengen(src);
  }

  function linkScheitern() {
    if (!link || link.getAttribute('data-rs-loox-zustand') !== 'laedt') return;
    window.clearTimeout(linkUhr);
    link.setAttribute('data-rs-loox-zustand', 'fehler');
    var karte = linkTeil('karte');
    var fehler = linkTeil('fehler');
    var knopf = linkTeil('oeffnen');
    var t = linkVorlage.getAttribute('data-text-fehler') || '';
    if (fehler) {
      fehler.textContent = t;
      fehler.hidden = !t;
    }
    if (karte) karte.hidden = false;
    linkMelden(t);
    var aktiv = document.activeElement;
    if (knopf && (!aktiv || aktiv === document.body || aktiv.id === 'MainContent')) knopf.focus();
  }

  function linkWeg() {
    window.clearTimeout(linkUhr);
    document.removeEventListener('keydown', linkTaste);
    var fokus = link.contains(document.activeElement);
    if (link.parentNode) link.parentNode.removeChild(link);
    link = null;
    linkFertig = true;
    if (fokus) inhaltFokus();
  }

  function linkErledigt() {
    if (link) linkWeg();
  }

  function linkSchliessen() {
    if (link && link.getAttribute('data-rs-loox-zustand') !== 'laedt') linkWeg();
  }

  function linkTaste(e) {
    if (!link || e.defaultPrevented || (e.key !== 'Escape' && e.key !== 'Esc')) return;
    var karte = linkTeil('karte');
    if (karte && karte.hidden) return;
    var aktiv = document.activeElement;
    if (aktiv && aktiv !== document.body && aktiv.id !== 'MainContent' && !link.contains(aktiv)) return;
    linkSchliessen();
  }

  document.addEventListener('click', function (e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;
    var knopf = ziel.closest('[data-rs-loox-laden]');
    if (knopf) {
      var bereich = knopf.closest('[data-rs-loox-bereich]');
      if (bereich) laden(bereich, false);
      return;
    }
    sprungLaden(e, ziel.closest('a'));
    if (!link || !link.contains(ziel)) return;
    if (ziel.closest('[data-rs-loox-link-oeffnen]')) linkOeffnen();
    else if (ziel.closest('[data-rs-loox-link-zu]')) linkSchliessen();
  });
  // Die Vorlage des Hinweises steht vor dem Skript, das diese Datei nachlädt: Der Hinweis kann sofort kommen.
  linkZeigen();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      linkZeigen();
    });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
